import React from "react";
import { Link } from "react-router-dom";
import HeroImage from "../../../assets/images/png/careerheader.webp";
import Eyebrow from "./Eyebrow";

const HeroSection = () => {
  return (
    <>
      <section
        className="grid grid-cols-1 lg:grid-cols-corp-hero items-center gap-[34px] lg:gap-[58px] max-w-[1280px] mx-auto px-[18px] sm:px-[26px] pt-[54px] sm:pt-[58px] lg:pt-[74px] pb-8 sm:pb-12"
        aria-labelledby="page-heading"
      >
        <div>
          <Eyebrow>CONSULTING PRACTICE</Eyebrow>
          <p className="text-[#6f7890] text-sm-15 font-650 -mt-2 mb-[18px]">
            Impact &amp; Resources
          </p>
          <h1
            id="page-heading"
            className="max-w-[720px] text-primary font-bold tracking-[-0.055em] mb-[26px] text-[43px] sm:text-corp-hero leading-[1.03]"
          >
            Transform your workforce for the work that is coming{" "}
            <em
              className="not-italic bg-secondary text-primary px-[0.07em]"
              style={{
                WebkitBoxDecorationBreak: "clone",
                boxDecorationBreak: "clone",
              }}
            >
              next.
            </em>
          </h1>
          <p className="max-w-[680px] text-[#555b6e] text-[17px] sm:text-[19px] leading-[1.78] m-0">
            Utiva helps organisations diagnose capability gaps, design relevant
            learning and deliver practical workforce transformation programmes.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-5 mt-[31px]">
            <a
              href="mailto:info@utiva.io?subject=Corporate%20Training%20Enquiry"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-[11px] min-h-[54px] px-[22px] py-[14px] rounded-xl border border-primary bg-primary text-white text-[15px] font-750 shadow-corp-btn transition-all duration-[180ms] hover:bg-[#03045f] hover:-translate-y-0.5"
            >
              Discuss your workforce <span aria-hidden="true">↗</span>
            </a>
            <Link
              to="/business"
              className="text-primary underline underline-offset-[5px] text-base font-750 text-center sm:text-left py-2 sm:py-0"
            >
              Explore Utiva Business <span aria-hidden="true">↓</span>
            </Link>
          </div>
        </div>

        <figure className="relative m-0 overflow-hidden bg-primary rounded-[22px] lg:rounded-[30px] h-[470px] sm:h-[540px] lg:h-[560px] xl:h-[610px] shadow-corp-hero-visual">
          <img
            src={HeroImage}
            alt="The Utiva team planning learning and workforce programmes"
            fetchpriority="high"
            className="w-full h-full object-cover object-[center_28%]"
          />
          <span
            className="absolute top-[28%] inset-x-0 bottom-0"
            aria-hidden="true"
            style={{ backgroundImage: "linear-gradient(#00000000, #03045ff2)" }}
          />
          <figcaption className="absolute z-[1] text-white bottom-[22px] left-[21px] right-[21px] sm:bottom-[30px] sm:left-[30px] sm:right-[30px]">
            <span className="text-secondary tracking-[0.1em] text-sm font-850">
              WORKFORCE DIGITAL TRANSFORMATION
            </span>
            <strong className="block max-w-[520px] mt-[11px] text-2xl sm:text-[29px] leading-[1.3]">
              More than training: an end-to-end capability development
              programme.
            </strong>
          </figcaption>
        </figure>

        <p className="relative z-[2] text-[#e2e7ff] text-sm mx-[5px] -mt-[47px] mb-0 lg:col-start-2">
          Photography from the Utiva community.
        </p>
      </section>

      <section
        className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[#ccd7ef] border-y border-[#dce4f5] bg-[#f1f5ff] py-8 px-[18px] sm:px-[max(26px,50vw-640px)]"
        aria-label="Page highlights"
      >
        <div className="flex flex-col justify-center min-h-[96px] py-[22px] sm:py-[10px] px-0 sm:px-[34px] first:pl-0 last:pr-0">
          <strong className="text-primary tracking-[-0.035em] text-[31px] leading-[1.2]">
            200+
          </strong>
          <span className="text-[#555b6e] mt-[7px] text-sm-15 leading-normal">
            business partnerships reflected by Utiva
          </span>
        </div>
        <div className="flex flex-col justify-center min-h-[96px] py-[22px] sm:py-[10px] px-0 sm:px-[34px] first:pl-0 last:pr-0">
          <strong className="text-primary tracking-[-0.035em] text-[31px] leading-[1.2]">
            Custom
          </strong>
          <span className="text-[#555b6e] mt-[7px] text-sm-15 leading-normal">
            content and business cases
          </span>
        </div>
        <div className="flex flex-col justify-center min-h-[96px] py-[22px] sm:py-[10px] px-0 sm:px-[34px] first:pl-0 last:pr-0">
          <strong className="text-primary tracking-[-0.035em] text-[31px] leading-[1.2]">
            End-to-end
          </strong>
          <span className="text-[#555b6e] mt-[7px] text-sm-15 leading-normal">
            diagnosis through delivery
          </span>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
